import React from "react";
import { Youtube } from "lucide-react";
import { useLanguage } from "../context/LanguageContext";

export const Footer = () => {
  const { t } = useLanguage();
  const year = new Date().getFullYear();

  return (
    <footer
      data-testid="site-footer"
      className="bg-[#070707] border-t border-white/8 py-14 px-6 lg:px-12"
    >
      <div className="max-w-7xl mx-auto">
        <div className="grid md:grid-cols-3 gap-8 items-start">
          <div>
            <div className="flex items-center gap-3">
              <span className="w-9 h-9 border border-[#D4AF37] flex items-center justify-center font-serif-bodoni text-[#D4AF37] text-lg">
                P
              </span>
              <div className="leading-tight">
                <div className="font-serif-display text-xl text-[#FDFBF7]">
                  Proscenio
                </div>
                <div className="overline text-[10px] tracking-[0.3em] -mt-0.5">
                  Ensemble
                </div>
              </div>
            </div>
            <p className="mt-5 text-sm text-[#A1A1AA] font-light italic font-serif-display max-w-xs leading-relaxed">
              {t.footer.tagline}
            </p>
            <a
              href="https://www.youtube.com/@proscenioensemble"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-youtube"
              aria-label="YouTube — Proscenio Ensemble"
              className="mt-6 inline-flex items-center gap-3 border border-white/15 hover:border-[#D4AF37] hover:bg-[#D4AF37]/5 px-4 py-2.5 text-xs tracking-[0.25em] uppercase text-[#A1A1AA] hover:text-[#D4AF37] transition-all"
            >
              <Youtube size={16} />
              YouTube
            </a>
          </div>

          <div>
            <div className="overline mb-4">Contact</div>
            <p className="text-sm text-[#A1A1AA] font-light leading-relaxed">
              {t.contact.address}
            </p>
            <a
              href={`mailto:${t.contact.email}`}
              data-testid="footer-email"
              className="block mt-2 text-sm text-[#FDFBF7] gold-link"
            >
              {t.contact.email}
            </a>
          </div>

          <div>
            <div className="overline mb-4">Discography</div>
            <ul className="space-y-2 text-sm text-[#A1A1AA] font-light">
              <li>
                <a
                  href="https://open.spotify.com/album/2ESmQ0zCWUTU0nrArWWCkj"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="gold-link"
                  data-testid="footer-album-1"
                >
                  Sonorités Oubliées (2023)
                </a>
              </li>
              <li>
                <a
                  href="https://open.spotify.com/album/1KtJ452k0b9RxUZHahjpoQ"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="gold-link"
                  data-testid="footer-album-2"
                >
                  Ô doux printemps d'autrefois (2020)
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-white/8 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-[#71717A]">
          <span>© {year} Proscenio Ensemble. {t.footer.rights}</span>
          <span className="font-serif-bodoni italic">
            Da Vinci Publishing — Osaka, Japan
          </span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
